import { render, staticRenderFns } from "./EditUserProfileConfirm.vue?vue&type=template&id=4c632d90&scoped=true&"
import script from "./EditUserProfileConfirm.vue?vue&type=script&lang=js&"
export * from "./EditUserProfileConfirm.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfileConfirm.vue?vue&type=style&index=0&id=4c632d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c632d90",
  null
  
)

export default component.exports